import React, { useState } from "react";
import "./FlightRecon.scss";
import PageHeader from "app/shared/PageHeader";
import { AgTableClient } from "app/shared/AgTable";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  RightCircleOutlined,
} from "@ant-design/icons";
import ToolParamInvoker from "app/shared/AgTable/HelperTools/ToolParamInvoker";
import { handleCellRenderer } from "app/shared/AgTable/AgUtility";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

import JsonData from "./demo.json";
import { useRecoilState } from "recoil";
import { currentPDFData } from "app/config/States/users";
import { Button, Tag, Tooltip } from "antd";
import Typography from "app/shared/Typography";
import PendingIcon from "@mui/icons-material/Pending";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import AdsClickOutlinedIcon from "@mui/icons-material/AdsClickOutlined";
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import UnsubscribeOutlinedIcon from "@mui/icons-material/UnsubscribeOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import MarkunreadMailboxOutlinedIcon from "@mui/icons-material/MarkunreadMailboxOutlined";
import ScheduleSendOutlinedIcon from "@mui/icons-material/ScheduleSendOutlined";
import { colorPicker } from "app/utils/color.helper";
import moment from "moment";
function generateUAEVATID() {
  let vatId = "";
  for (let i = 0; i < 15; i++) {
    vatId += Math.floor(Math.random() * 10);
  }
  return vatId;
}

const colorOfEmailEvent: any = {
  processed: colorPicker("primary.700"),
  delivered: colorPicker("primary.700"),
  open: colorPicker("primary.700"),
  click: colorPicker("primary.700"),
  bounce: "#e74c3c",
  dropped: "#e74c3c",
  spammed: "#e74c3c",
  deffered: "#e74c3c",
};

function generateHotelInvoiceNumber(hotelCode = "DXB-RAD") {
  const datePart = new Date().toISOString().slice(0, 10).replace(/-/g, ""); // e.g., 20250506
  const randomSerial = Math.floor(1000 + Math.random() * 9000); // e.g., 4-digit serial
  return `${hotelCode}-${datePart}-${randomSerial}`;
}
const initialColDef = [
  {
    headerName: "Status",
    children: [
      // {
      //   headerName: "Overall Status",
      //   field: "Overall Status",
      //   enableRowGroup: true,
      // },
      {
        headerName: "ERP Match Status",
        field: "ERP Matching Status",
        enableRowGroup: true,
        formatType: "MATCH",
        ...handleCellRenderer(),
        filter: "agSetColumnFilter",
        filterParams: {
          values: ["Match", "MismMISMATCHat"], // Predefined values for the selector
        },
        pivot: true,
        formatProps: {
          matchLogic: {
            matchColor: {
              Match: "green",
              MISMATCH: "red",
            },
            icon: {
              Match: <CheckCircleFilled />,
              MISMATCH: <CloseCircleFilled />,
            },
          },
          defaultText: "Not Available",
        },
      },
      {
        headerName: "Invoice Received Status",
        field: "Invoice Received Status",
        enableRowGroup: true,
        formatType: "MATCH",
        filter: "agSetColumnFilter",
        filterParams: {
          values: ["Invoice Received", "Invoice Not Received"], // Predefined values for the selector
        },
        ...handleCellRenderer(),
        pivot: true,
        formatProps: {
          matchLogic: {
            matchColor: {
              "Invoice Received": "green",
              "Invoice Not Received": "red",
            },
            icon: {
              "Invoice Received": <CheckCircleFilled />,
              "Invoice Not Received": <CloseCircleFilled />,
            },
          },
          defaultText: "Not Available",
        },
      },
      {
        headerName: "Amount Matching Status",
        field: "Amount Matching Status",
        enableRowGroup: true,
        formatType: "MATCH",
        ...handleCellRenderer(),
        filter: "agSetColumnFilter",
        filterParams: {
          values: ["Match", "MISMATCH"], // Predefined values for the selector
        },
        pivot: true,
        formatProps: {
          matchLogic: {
            matchColor: {
              Match: "green",
              MISMATCH: "red",
            },
            icon: {
              Match: <CheckCircleFilled />,
              MISMATCH: <CloseCircleFilled />,
            },
          },
          defaultText: "Not Available",
        },
      },
      {
        headerName: "Commission Status",
        field: "Commission Status",
        enableRowGroup: true,
        formatType: "MATCH",
        ...handleCellRenderer(),
        filter: "agSetColumnFilter",
        filterParams: {
          values: ["Commission Received", "Commission Not Received"], // Predefined values for the selector
        },
        pivot: true,
        formatProps: {
          matchLogic: {
            matchColor: {
              "Commission Received": "green",
              "Commission Not Received": "red",
            },
            icon: {
              "Commission Received": <CheckCircleFilled />,
              "Commission Not Received": <CloseCircleFilled />,
            },
          },
          defaultText: "Not Available",
        },
      },
    ],
  },

  {
    headerName: "Booking Details",
    children: [
      {
        headerName: "SUPPLIER NAME",
        field: "SUPPLIER NAME",
        filter: "agTextColumnFilter",
        formatType: "ENTITY",
        columnGroupShow: ["open", "close"],
        ...handleCellRenderer(),
      },
      {
        headerName: "SUPPLIER CONFIRMATION NO.",
        field: "SUPPLIER CONFIRMATION NO.",
        filter: "agTextColumnFilter",
        ...handleCellRenderer(),
        columnGroupShow: ["open", "close"],
      },
      {
        headerName: "SUPPLIER REFERENCE NO.",
        field: "SUPPLIER REFERENCE NO.",
        filter: "agTextColumnFilter",
        columnGroupShow: "open",
        ...handleCellRenderer(),
      },
      {
        headerName: "TBOH CONFIRMATION NO.",
        field: "TBOH CONFIRMATION NO.",
        filter: "agTextColumnFilter",
        columnGroupShow: "open",
        ...handleCellRenderer(),
      },

      {
        headerName: "HOTEL Code",
        field: "HOTEL Code",
        filter: "agTextColumnFilter",
        columnGroupShow: "open",
        ...handleCellRenderer(),
      },
      {
        headerName: "Giata code",
        field: "Giata code",
        filter: "agNumberColumnFilter",
        enableValue: true,
        columnGroupShow: "open",
        ...handleCellRenderer(),
      },
      {
        headerName: "TBOM Reference Number",
        field: "TBOM Reference Number",
        filter: "agTextColumnFilter",
        columnGroupShow: "open",
        ...handleCellRenderer(),
      },
      {
        headerName: "Type of Supplier",
        field: "Type of Supplier",
        filter: "agTextColumnFilter",
        columnGroupShow: "open",
        ...handleCellRenderer(),
      },
      {
        headerName: "CHECK-IN DATE",
        field: "CHECK-IN DATE",
        filter: "agTextColumnFilter",
        columnGroupShow: "open",
        ...handleCellRenderer(),
      },
      {
        headerName: "CHECK-OUT DATE",
        field: "CHECK-OUT DATE",
        filter: "agTextColumnFilter",
        ...handleCellRenderer(),
        columnGroupShow: "open",
      },
      {
        headerName: "Month",
        field: "Monthj",
        filter: "agTextColumnFilter",
        ...handleCellRenderer(),
        columnGroupShow: "open",
      },
      {
        headerName: "Guest Name",
        field: "Guest Name",
        filter: "agTextColumnFilter",
        columnGroupShow: "open",
        ...handleCellRenderer(),
      },
    ],
  },

  {
    headerName: "Hotel Details",
    children: [
      {
        headerName: "Hotel Name",
        field: "Hotel Name",
        filter: "agTextColumnFilter",
        columnGroupShow: ["open", "close"],
        formatType: "ENTITY",
        ...handleCellRenderer(),
      },
      {
        headerName: "HCN",
        field: "HCN",
        enableRowGroup: true,
        filter: "agTextColumnFilter",
        columnGroupShow: ["open", "close"],
      },
      {
        headerName: "Mail Id",
        field: "Mail Id",
        filter: "agTextColumnFilter",
        columnGroupShow: "open",
      },

      {
        headerName: "Hotel City",
        field: "Hotel City",
        filter: "agDateColumnFilter",
        columnGroupShow: "open",
      },
      {
        headerName: "Country",
        field: "Country",
        filter: "agDateColumnFilter",
        columnGroupShow: "open",
      },

      {
        headerName: "Supplier registered Place",
        field: "Supplier registered Place",
        filter: "agTextColumnFilter",
        columnGroupShow: "open",
      },
    ],
  },

  {
    headerName: "Fare Details",
    children: [
      {
        headerName: "Net Supplier price USD",
        field: "Net Supplier price USD",
        filter: "agTextColumnFilter",
        columnGroupShow: "open",
        formatType: "AMOUNT_USD",
        ...handleCellRenderer(),
      },
      {
        headerName: "Amt in AED",
        field: "Amt in AED",
        filter: "agTextColumnFilter",
        columnGroupShow: "open",
        formatType: "AMOUNT_AED",
        ...handleCellRenderer(),
      },
      {
        headerName: "VAT Amt AED",
        field: "VAT Amt AED",
        enableRowGroup: true,
        filter: "agTextColumnFilter",
        columnGroupShow: ["open", "close"],
        formatType: "AMOUNT_AED",
        ...handleCellRenderer(),
      },
      {
        headerName: "VAT Amt INR",
        field: "VAT Amt INR",
        enableRowGroup: true,
        filter: "agTextColumnFilter",
        columnGroupShow: ["open", "close"],
        formatType: "AMOUNT",
        ...handleCellRenderer(),
      },
    ],
  },

  {
    headerName: "Payment Details",
    children: [
      {
        headerName: "Trans ID",
        field: "Trans ID",
        filter: "agTextColumnFilter",
        columnGroupShow: ["open", "close"],
      },
      {
        headerName: "Net Settled",
        field: "Net Settled",
        filter: "agTextColumnFilter",
        columnGroupShow: ["open", "close"],
        formatType: "AMOUNT_AED",
        ...handleCellRenderer(),
      },
      {
        headerName: "Difference amount",
        field: "Difference amount",
        enableRowGroup: true,
        filter: "agTextColumnFilter",
        columnGroupShow: ["open", "close"],
        formatType: "AMOUNT_AED",
        ...handleCellRenderer(),
      },
    ],
  },

  {
    headerName: "Comission Details",
    children: [
      {
        headerName: "Amt in AED",
        field: "Amt in AED",
        filter: "agTextColumnFilter",
        columnGroupShow: "open",
        formatType: "AMOUNT_AED",
        ...handleCellRenderer(),
      },
      {
        headerName: "Amt in INR",
        field: "Amt in INR",
        filter: "agTextColumnFilter",
        columnGroupShow: "open",
        formatType: "AMOUNT",
        ...handleCellRenderer(),
      },
    ],
  },
  {
    headerName: "Invoice Details",
    children: [
      {
        headerName: "Hotel Name",
        field: "Hotel Name",
        formatType: "ENTITY",
        ...handleCellRenderer(),
        columnGroupShow: ["open", "close"],
      },
      {
        headerName: "Hotel Invoice Number",
        field: "Hotel Invoice Number",
        enableRowGroup: true,
        ...handleCellRenderer(),
        cellRenderer: (params: any) => {
          return params.data?.["Invoice Received Status"] === "Invoice Received"
            ? generateHotelInvoiceNumber()
            : "";
        },
        columnGroupShow: ["open", "close"],
      },
      {
        headerName: "VAT ID",
        field: "VAT ID",
        enableRowGroup: true,
        ...handleCellRenderer(),
        cellRenderer: (params: any) => {
          return params.data?.["Invoice Received Status"] === "Invoice Received"
            ? generateUAEVATID()
            : "";
        },
        columnGroupShow: ["open", "close"],
      },
      {
        headerName: "Hotel Address",
        field: "Hotel Address",
        enableRowGroup: true,
        ...handleCellRenderer(),
        columnGroupShow: "open",
      },
      {
        headerName: "HCN",
        field: "HCN",
        enableRowGroup: true,
        ...handleCellRenderer(),
        columnGroupShow: "open",
      },
      {
        headerName: "Guest Name",
        field: "Guest Name",
        enableRowGroup: true,
        ...handleCellRenderer(),
        columnGroupShow: "open",
      },
      {
        headerName: "Check In date",
        field: "Check In date",
        enableRowGroup: true,
        ...handleCellRenderer(),
        columnGroupShow: "open",
      },
      {
        headerName: "Check Out",
        field: "Check Out",
        enableRowGroup: true,
        ...handleCellRenderer(),
        columnGroupShow: "open",
      },

      {
        headerName: "VAT Amount",
        field: "VAT Amount",
        enableRowGroup: true,
        ...handleCellRenderer(),
        columnGroupShow: "open",
        formatType: "AMOUNT_AED",
        ...handleCellRenderer(),
      },
      {
        headerName: "Municipal Tax",
        field: "Municipal Tax",
        enableRowGroup: true,
        ...handleCellRenderer(),
        columnGroupShow: "open",
        formatType: "AMOUNT_AED",
        ...handleCellRenderer(),
      },
      {
        headerName: "Taxable Amount",
        field: "Taxable Amount",
        enableRowGroup: true,
        ...handleCellRenderer(),
        columnGroupShow: "open",
        formatType: "AMOUNT_AED",
        ...handleCellRenderer(),
      },
      {
        headerName: "Invoice Amount",
        field: "Invoice Amount",
        enableRowGroup: true,
        columnGroupShow: "open",
        formatType: "AMOUNT_AED",
        ...handleCellRenderer(),
        ...handleCellRenderer(),
      },
    ],
  },
];

const EVENT_ICON_MAP = {
  processed: (color: any) => (
    <CheckOutlinedIcon
      style={{
        fontSize: 18,
        color: color,
        cursor: "pointer",
      }}
    />
  ),
  delivered: (color: any) => (
    <DoneAllOutlinedIcon
      style={{
        fontSize: 18,
        color: color,
        cursor: "pointer",
      }}
    />
  ),
  open: (color: any) => (
    <DraftsOutlinedIcon
      style={{
        fontSize: 18,
        color: color,
        cursor: "pointer",
      }}
    />
  ),
  click: (color: any) => (
    <AdsClickOutlinedIcon
      style={{
        fontSize: 18,
        color: color,
        cursor: "pointer",
      }}
    />
  ),
  acknowledge: (color: any) => (
    <AssignmentTurnedInIcon
      style={{
        fontSize: 18,
        color: color,
        cursor: "pointer",
        marginRight: 28,
      }}
    />
  ),

  UNSUBSCRIBE: (color: any) => (
    <UnsubscribeOutlinedIcon
      style={{
        fontSize: 18,
        color: color,
        cursor: "pointer",
      }}
    />
  ),
  SPAMMED: (color: any) => (
    <PrivacyTipOutlinedIcon
      style={{
        fontSize: 18,
        color: color,
        cursor: "pointer",
      }}
    />
  ),
  bounce: (color: any) => (
    <CancelOutlinedIcon
      style={{
        fontSize: 18,
        color: color,
        cursor: "pointer",
      }}
    />
  ),

  dropped: (color: any) => (
    <MarkunreadMailboxOutlinedIcon
      style={{
        fontSize: 18,
        color: color,
        cursor: "pointer",
      }}
    />
  ),

  DEFFERED: (color: any) => (
    <ScheduleSendOutlinedIcon
      style={{
        fontSize: 18,
        color: color,
        cursor: "pointer",
      }}
    />
  ),
};

function formatDate(timestamp: any) {
  // Convert Unix timestamp to milliseconds
  const date = new Date(timestamp * 1000);

  // Use Moment.js to format the date
  const formattedDate = moment(date).format("DD-MM-YYYY, HH:MM A");

  return formattedDate;
}

export default function FlightRecon(props: any) {
  const [pdfViewerData, setPdfViewerData] = useState("");
  const [_, setCurrentPDFData] = useRecoilState(currentPDFData);
  const openSidebarRenderer = (params: any) => {
    setCurrentPDFData(params?.data);
    params.api.openToolPanel("pdfRenderer", { paramData: params });
  };

  const handleRenderEmailEvents = (eventData: any) => {
    return (
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        {Object.entries(EVENT_ICON_MAP).map((emailEvent: any) => {
          return (
            <div
              style={{
                marginRight: 6,
                display: "flex",
                height: "100%",
                alignItems: "center",
              }}
            >
              <Tooltip
                placement="bottom"
                title={
                  <div>
                    <Typography
                      style={{ color: "white", marginBottom: 12 }}
                      variant="xs"
                    >
                      {emailEvent[0]}
                    </Typography>
                    {(eventData?.[emailEvent[0]] || []).map((reader: any) => {
                      return (
                        <Tag key={reader.email} style={{ fontSize: 10 }}>
                          {reader.email} at {formatDate(reader.timestamp)}
                        </Tag>
                      );
                    })}
                  </div>
                }
              >
                {emailEvent[1](
                  eventData?.[emailEvent[0]]
                    ? colorOfEmailEvent[emailEvent[0]]
                    : "rgb(192 194 197)"
                )}
              </Tooltip>
            </div>
          );
        })}
      </div>
    );
  };
  const invoiceLinkMap: any = {
    "Radisson Blu Hotel & ResortAbu Dhabi Corniche":
      "https://files.finkraft.ai/4f17786e73cb83165f09dd932dc2a50a",
    "Golden Tulip Deira Hotel":
      "https://files.finkraft.ai/14d3f78b8834369243fbe09f852c530a",
    "Jannah Hotel Apartments & Villas":
      "https://files.finkraft.ai/dda19c95b82e401c13838aa32394f9ff",
    Hilton: "https://files.finkraft.ai/a47cf2dc9c8e905cfa9f907ce8f3ccfe",
  };

  const columnDefs = [
    {
      headerName: "Invoice",
      field: "Invoice_Link",
      filter: "agTextColumnFilter",
      invoiceLink: "html.pdf",
      cellRenderer: ToolParamInvoker,
      cellRendererParams: (params: any) => {
        return {
          label: "View Invoice",
          handleClick: openSidebarRenderer,
          data: params.data?.Invoice_Link || params?.value,
        };
      },
    },

    {
      headerName: "Send Email",
      field: "Send Email",
      cellRenderer: (params: any) => {
        return params?.data?.["Send Email"] &&
          params.data?.["Invoice Received Status"] ===
            "Invoice  Not Received" ? (
          <Button size="small" type="primary">
            {params?.data?.["Send Email"]}
          </Button>
        ) : null;
      },
    },

    ...initialColDef,

    {
      headerName: "Email Event Logs",
      children: [
        {
          field: "booking_events",
          headerName: "Booking Email",
          width: 300,
          columnGroupShow: ["open", "close"],
          formatType: "CUSTOM_RENDER",
          filter: "agSetColumnFilter",
          filterParams: {
            values: [
              "processed",
              "dropped",
              "deferred",
              "bounce",
              "delivered",
              "open",
              "click",
            ],
            valueFormatter: (params: any) =>
              Array.isArray(params.value)
                ? params.value.join(", ")
                : params.value,
            comparator: (a: any, b: any) => a.localeCompare(b),
          },
          ...handleCellRenderer(),
          formatProps: {
            cellRenderer: (data: any, params: any) => {
              return handleRenderEmailEvents(
                params?.email_events?.BOOKING || null
              );
            },
            valueGetterData: (params: any) => {
              return Array.isArray(
                Object.keys(params?.email_events?.BOOKING || {})
              )
                ? Object.keys(params?.email_events?.BOOKING || {})
                : [];
            },
          },
        },
        {
          field: "checkin_events",
          headerName: "Checkin Email",
          width: 300,
          columnGroupShow: "open",
          formatType: "CUSTOM_RENDER",
          filter: "agSetColumnFilter",
          filterParams: {
            values: [
              "processed",
              "dropped",
              "deferred",
              "bounce",
              "delivered",
              "open",
              "click",
            ],
            valueFormatter: (params: any) =>
              Array.isArray(params.value)
                ? params.value.join(", ")
                : params.value,
            comparator: (a: any, b: any) => a.localeCompare(b),
          },
          ...handleCellRenderer(),
          formatProps: {
            cellRenderer: (data: any, params: any) => {
              return handleRenderEmailEvents(
                params?.email_events?.CHECKIN || null
              );
            },
            valueGetterData: (params: any) => {
              return Array.isArray(
                Object.keys(params?.email_events?.CHECKIN || {})
              )
                ? Object.keys(params?.email_events?.CHECKIN || {})
                : [];
            },
          },
        },
        {
          field: "checkout_events",
          headerName: "Checkout Email",
          width: 300,
          columnGroupShow: "open",
          formatType: "CUSTOM_RENDER",
          filter: "agSetColumnFilter",
          filterParams: {
            values: [
              "processed",
              "dropped",
              "deferred",
              "bounce",
              "delivered",
              "open",
              "click",
            ],
            valueFormatter: (params: any) =>
              Array.isArray(params.value)
                ? params.value.join(", ")
                : params.value,
            comparator: (a: any, b: any) => a.localeCompare(b),
          },
          ...handleCellRenderer(),
          formatProps: {
            cellRenderer: (data: any, params: any) => {
              return handleRenderEmailEvents(params?.email_events?.COMPLETED);
            },
            valueGetterData: (params: any) => {
              return Array.isArray(
                Object.keys(params?.email_events?.COMPLETED || {})
              )
                ? Object.keys(params?.email_events?.COMPLETED || {})
                : [];
            },
          },
        },
        {
          field: "checkin_date",
          headerName: "Monthly Report Email",
          width: 300,
          columnGroupShow: "open",
          formatType: "CUSTOM_RENDER",
          ...handleCellRenderer(),
          cellRenderer: (params: any) => {
            return handleRenderEmailEvents(
              params.data?.email_events?.MONTHLY_REPORT
            );
          },
        },
        {
          field: "checkin_date",
          headerName: "Before GSTR Filling Email",
          width: 300,
          columnGroupShow: "open",
          formatType: "CUSTOM_RENDER",
          ...handleCellRenderer(),

          formatProps: {
            cellRenderer: (data: any, params: any) => {
              return handleRenderEmailEvents(params?.email_events?.BEFORE_GSTR);
            },
          },
        },
        {
          field: "checkin_date",
          headerName: "After GSTR 2B Email",
          width: 300,
          columnGroupShow: "open",
          formatType: "CUSTOM_RENDER",
          ...handleCellRenderer(),
          formatProps: {
            cellRenderer: (data: any, params: any) => {
              return handleRenderEmailEvents(params?.email_events?.AFTER_GSTR);
            },
          },
        },
      ],
    },
    {
      field: "booking_data",
      headerName: "Template",
      width: 200,
      formatType: "CUSTOM_RENDER",
      exportIgnore: true,
      formatProps: {
        cellRenderer: (data: any, params: any) => {
          return (
            <div
              style={{
                height: "100%",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {[0, 1, 2, 3, 4, 5].map((template, key) => {
                return (
                  <div
                    style={{
                      width: 18,
                      height: 18,
                      background: "#34495e",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "50%",
                      color: "white",
                      cursor: "pointer",
                      marginRight: 8,
                    }}
                    key={key}
                  >
                    {template + 1}
                  </div>
                );
              })}
            </div>
          );
        },
        valueGetterData: (params: any) => params,
      },
    },
  ];
  return (
    <div className="FlightRecon" style={{ height: "100%" }}>
      <AgTableClient
        /* @ts-ignore */
        columnDefs={columnDefs}
        rowData={JsonData}
        groupPanel
        enablePdfViewer
        pdfDataKey="Invoice_Link"
      />
    </div>
  );
}
